import {
  GET_CSV_FILE,GET_CSV_FILE_SUCCESS,GET_CSV_FILE_FAILED, IMPORT_MIGRATION_DATA, IMPORT_MIGRATION_DATA_SUCCESS, IMPORT_MIGRATION_DATA_FAILED, FIELD_MAP_DATA, FIELD_MAP_DATA_SUCCESS, FIELD_MAP_DATA_FAILED, BULK_IMPORT_MIGRATION_DATA, BULK_IMPORT_MIGRATION_DATA_SUCCESS, BULK_IMPORT_MIGRATION_DATA_FAILED, GET_MIGRATION_IDS, GET_MIGRATION_IDS_SUCCESS, GET_MIGRATION_IDS_FAILED, GET_MIGRATION_STATUS, GET_MIGRATION_STATUS_SUCCESS, GET_MIGRATION_STATUS_FAILED
} from "./actionTypes"

export const getCsvFile = (data) => {
  return {
    type: GET_CSV_FILE,
    payload:data,
  
  }
}

export const getCsvFileSuccess = data => {
  return {
    type: GET_CSV_FILE_SUCCESS,
    payload: data
    
  
    
  }
}

export const getCsvFileFailed = error => {
  return {
    type: GET_CSV_FILE_FAILED,
    payload: error
    
  }
}

export const importMigrationData = (data) => {
  return {
    type: IMPORT_MIGRATION_DATA,
    payload:data,
  
  }
}

export const importMigrationDataSuccess = data => {
  return {
    type: IMPORT_MIGRATION_DATA_SUCCESS,
    payload: data
    
  
    
  }
}

export const importMigrationDataFailed = error => {
  return {
    type: IMPORT_MIGRATION_DATA_FAILED,
    payload: error
    
  }
}

export const fieldMapData = (data) => {
  return {
    type: FIELD_MAP_DATA,
    payload:data,
  
  }
}

export const fieldMapDataSuccess = data => {
  return {
    type: FIELD_MAP_DATA_SUCCESS,
    payload: data
    
  
    
  }
}

export const fieldMapDataFailed = error => {
  return {
    type: FIELD_MAP_DATA_FAILED,
    payload: error
    
  }
}

export const bulkImportMigrationData = (data) => {
  return {
    type: BULK_IMPORT_MIGRATION_DATA,
    payload:data,
  
  }
}

export const bulkImportMigrationDataSuccess = data => {
  return {
    type: BULK_IMPORT_MIGRATION_DATA_SUCCESS,
    payload: data
    
  
    
  }
}

export const bulkImportMigrationDataFailed = error => {
  return {
    type: BULK_IMPORT_MIGRATION_DATA_FAILED,
    payload: error
    
  }
}

export const getMigrationIds=(data)=>{
  return {
    type:GET_MIGRATION_IDS,
    payload:data
  }

}

export const getMigrationIdsSuccess=(data)=>{
  return {
    type:GET_MIGRATION_IDS_SUCCESS,
    payload:data
  }

}

export const getMigrationIdsFailed=(data)=>{
  return {
    type:GET_MIGRATION_IDS_FAILED,
    payload:data
  }

}

export const getMigrationStatus=(data)=>{
  return {
    type:GET_MIGRATION_STATUS,
    payload:data
  }

}

export const getMigrationStatusSuccess=(data)=>{
  return {
    type:GET_MIGRATION_STATUS_SUCCESS,
    payload:data
  }

}

export const getMigrationStatusFailed=(data)=>{
  return {
    type:GET_MIGRATION_STATUS_FAILED,
    payload:data
  }

}



